export const SMETA_EXECUTE_TAB = 'SMETA_EXECUTE_TAB';